import React from 'react';
import { useRouter } from 'next/router';
import {
  enTermsConditions,
  frTermsConditions,
  deTermsConditions,
} from './TranslatedTermsAndConditions';
import PageHeader from 'components/molecules/PageHeader/PageHeader';
import { MORE } from 'components/pages/pages';

export interface Props {
  className?: string;
}

// NOTE / TODO: This has been translated without the use of the
// useTranslate hook because there is a vast quantity of
// translations needed. The plan is to translate this properly
// using Locize

const TermsAndConditions: React.FC<Props> = ({ className }) => {
  const { locale } = useRouter();

  let translatedTCs;
  if (locale === 'fr-fr') translatedTCs = frTermsConditions;
  else if (locale === 'de-de') translatedTCs = deTermsConditions;
  else translatedTCs = enTermsConditions;

  return (
    <main>
      <PageHeader title="Terms of Service" backHref={MORE.path} />
      <article className={className}>{translatedTCs}</article>
    </main>
  );
};
export default TermsAndConditions;
